import { useParams } from 'react-router-dom-v5-compat'

export const useCardId = () => {
  const { cardId } = useParams<'cardId'>()

  return { cardId: cardId || '' }
}
